import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=27f04513&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=27f04513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f04513",
  null
  
)

export default component.exports